// @flow

import moment from 'moment';

import {
  TRAINER_COMPLETED_CHALLENGES,
  TRAINER_LIVE_CHALLENGES,
  TRAINER_UPCOMING_CHALLENGES
} from '../constants/apiTypes';
import { sendQuery, stopChallengePolls } from './challengeListActions';
import { getTrainerChallenges } from '../api/trainerChallenges';

export function startTrainerChallengesPoll(force: boolean = false) {
  return (dispatch: Dispatch<*>, getState: () => GlobalState) => {
    const { trainerChallenges } = getState();

    dispatch(
      sendQuery({
        key: TRAINER_UPCOMING_CHALLENGES,
        query: getTrainerChallenges,
        queryParams: {
          embed: ['rule_set'],
          status: 'active'
        },
        runStraightAway: force || !trainerChallenges.upcomingInitialised
      })
    );

    dispatch(
      sendQuery({
        key: TRAINER_COMPLETED_CHALLENGES,
        query: getTrainerChallenges,
        queryParams: {
          embed: ['current_user_entry', 'rule_set'],
          min_end_time: moment()
            .subtract({ days: 10 })
            .startOf('day')
            .toISOString(),
          sort_by: 'start_time:desc',
          entered: true,
          status: 'closed'
        },
        runStraightAway: force || !trainerChallenges.completedInitialised
      })
    );

    dispatch(
      sendQuery({
        key: TRAINER_LIVE_CHALLENGES,
        query: getTrainerChallenges,
        queryParams: {
          embed: ['current_user_entry', 'rule_set'],
          status: 'running'
        },
        runStraightAway: force || !trainerChallenges.liveInitialised
      })
    );
  };
}

export function stopTrainerChallengessPoll() {
  return stopChallengePolls([
    TRAINER_COMPLETED_CHALLENGES,
    TRAINER_UPCOMING_CHALLENGES,
    TRAINER_LIVE_CHALLENGES
  ]);
}
